import React from 'react';
import { useTranslation } from 'react-i18next';
import './CategorySelector.css';

const CategorySelector = ({
  categories = {},
  selectedCategory,
  selectedSubcategory,
  onCategoryChange,
  onSubcategoryChange,
}) => {
  const { t } = useTranslation(['discovery']);

  // Определяем верный формат категорий
  let contentCategories = {};

  if (categories?.content_categories) {
    contentCategories = categories.content_categories;
  } else if (categories?.categories) {
    contentCategories = categories.categories;
  } else if (categories && typeof categories === 'object') {
    contentCategories = categories;
  }

  // Обработчик изменения категории
  const handleCategoryChange = (event) => {
    const category = event.target.value;
    
    if (category === '' || category === null || category === undefined) {
      onCategoryChange('');
    } else {
      onCategoryChange(category);
    }
  };

  // Проверяем наличие категорий
  const hasCategories = contentCategories && Object.keys(contentCategories).length > 0;

  return (
    <div className="category-selector">
      <div className="category-selector__group">
        <select
          id="category"
          className="category-selector__select"
          value={selectedCategory || ''}
          onChange={handleCategoryChange}
        >
          {/* Опция "Все категории" */}
          <option value="">{t('channelDiscovery.categorySelector.allCategories', 'Все категории')}</option>
          
          {/* Рендерим категории */}
          {hasCategories && Object.entries(contentCategories).map(([catKey, catData]) => {
            // Определяем базовое название для отображения
            let displayTitle = catKey;
            
            if (catData && typeof catData === 'object') {
              if (catData.title) {
                displayTitle = catData.title;
              }
            } else if (typeof catData === 'string') {
              displayTitle = catData;
            }
            
            // Пробуем найти перевод категории
            const translatedTitle = t(`categories.${catKey}`, displayTitle);
            displayTitle = translatedTitle;
            
            return (
              <option key={catKey} value={catKey}>
                {displayTitle}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default CategorySelector;